import { render, staticRenderFns } from "./chatNovedad.vue?vue&type=template&id=ccff489e&scoped=true&"
import script from "./chatNovedad.vue?vue&type=script&lang=js&"
export * from "./chatNovedad.vue?vue&type=script&lang=js&"
import style0 from "./chatNovedad.vue?vue&type=style&index=0&id=ccff489e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccff489e",
  null
  
)

export default component.exports